// extracted by mini-css-extract-plugin
export default {"div":"House_div__JMYDZ","link":"House_link__kanpL","image":"House_image__w6D5x","size":"House_size__g8hW-","price":"House_price__+zYo4","title":"House_title__P7FOJ"};